import React from "react";
import { useAsync, IfFulfilled, IfPending, IfRejected } from "react-async";
import { fetchWorkItemPDF } from "sagas/Api";
import BasicLoader from "components/UI/Loader";
import ErrorRetry from "components/UI/ErrorRetry";

const IframePdfRenderer = ({ workItemId, type, token }) => {
  const state = useAsync({
    promiseFn: getObjectURL,
    workItemId,
    type,
    token,
    watch: type
  });

  return (
    <>
      <IfPending state={state}>
        <BasicLoader />
      </IfPending>
      <IfRejected state={state}>
        <ErrorRetry
          message="The PDF could not be loaded. Please try again"
          onRetry={state.reload}
        />
      </IfRejected>
      <IfFulfilled state={state}>
        {url => <iframe title="PDF Service" src={url} style={{ flex: 1 }} />}
      </IfFulfilled>
    </>
  );
};

async function getObjectURL({ workItemId, type, token }) {
  const response = await fetchWorkItemPDF({
    workItemId,
    type,
    options: {
      headers: { Authorization: `Bearer ${token}` }
    }
  });

  if (response.status >= 300) {
    throw Error(response.statusText);
  }

  const blob = await response
    .blob()
    .then(data => new Blob([data], { type: "application/pdf" }));
  return URL.createObjectURL(blob);
}

export default IframePdfRenderer;
